import * as React from 'react';
import * as styles from './styles/Compteur.scss';

/**
 * Composant Compteur
 * Ce composant affiche un compteur qui s'incrémente de 0 jusqu'à une valeur donnée.
 * Utilise le hook useEffect pour gérer l'état du compteur.
 */

interface CompteurProps {
  title?: string; // Titre du compteur, optionnel
  value: number; // Valeur finale du compteur, le compteur s'incrémente jusqu'à cette valeur
  initialValue?: number; // Valeur initiale du compteur, par défaut 0
  delais?: number; // Délai en millisecondes pour l'animation du compteur
}

const Compteur: React.FC<CompteurProps> = (props: CompteurProps) => {
  // Référence pour le compteur, utile pour manipuler le DOM sans re-render
  const compteurRef = React.useRef<HTMLDivElement>(null);

  // ComponentDidMount equivalent in functional components
  // This effect runs once after the component mounts
  React.useEffect(() => {
    incNbrRec(0, props.value, props.delais != undefined ? props.delais : 10); // Commence l'animation de compteur
  }, []);

  // ComponentDidUpdate equivalent in functional components
  // This effect runs whenever props.value changes
  React.useEffect(() => {
    incNbrRec(0, props.value, props.delais != undefined ? props.delais : 10);
  }, [props.value]);

  /*A recursive function to increase the number.*/
  const incNbrRec = (currentNumber: number, endNumber: number, speed: number) => {
    if (currentNumber <= endNumber) {
      compteurRef.current.innerHTML = currentNumber.toString();
      setTimeout(function () {
        incNbrRec(currentNumber + 1, endNumber, speed);
      }, speed);
    }
  }

  // Render the component
  return (
    <div className={styles.compteurContainer}>
      <span className={styles.compteurNumber} ref={compteurRef}>{props.initialValue !== undefined ? props.initialValue : "0"}</span>
      {props.title && <span className={styles.compteurTitle}>{props.title}</span>}
    </div>
  );
};

export default Compteur;